// ----------------------------------------------------------------------

const shape = {
  borderRadius: 10,
  borderRadius2: 5,
  borderRadius3: 15
};

export default shape;
